import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { IMAGES, CONTACT } from '../mock';
import lotusFlower from '../assets/lotus-flower.png';

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden">
      <div className="relative h-[480px] md:h-[540px]">
        <img src={IMAGES.sunriseWater} alt="Peaceful lake at sunrise" className="absolute inset-0 w-full h-full object-cover animate-slow-zoom" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(120deg, rgba(232,165,169,0.55) 0%, rgba(250,247,242,0.35) 50%, rgba(141,150,119,0.4) 100%)' }} />

        {/* Floating lotus accent on left */}
        <img src={lotusFlower} alt="" aria-hidden="true" className="hidden md:block absolute left-6 bottom-6 w-40 lg:w-56 animate-float drop-shadow-[0_10px_25px_rgba(78,87,69,0.25)]" />

        <div className="relative h-full max-w-4xl mx-auto px-6 md:px-10 flex flex-col items-center justify-center text-center">
          <div className="font-script text-4xl md:text-6xl text-white drop-shadow-md mb-4 animate-fade-up">Let Your Light Shine</div>
          <h2 className="font-serif-display text-3xl md:text-5xl text-white leading-tight mb-6 drop-shadow-sm animate-fade-up" style={{ animationDelay: '0.2s' }}>
            You are not alone. <span className="italic">Hope starts here.</span>
          </h2>
          <div className="flex flex-wrap items-center justify-center gap-5 animate-fade-up" style={{ animationDelay: '0.4s' }}>
            <Link to="/schedule" className="btn-primary btn-glow">Schedule an Appointment</Link>
            <a href={CONTACT.phoneHref} className="text-white flex items-center gap-2 hover:underline">
              <Phone className="w-4 h-4" /> Or call {CONTACT.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
